// extracted by mini-css-extract-plugin
module.exports = {"container":"PreOrderAttendeesCountTag_container__Mxj68"};